const article = {
  id: "priznaki-neestestvennogo-trafika",
  metaTitle: "Неестественный трафик на сайте: как его распознать | Boostclick",
  metaDescription: "Признаки роботного трафика в Яндекс Метрике и Вебмастере: отчёт «Мониторинг → Роботы», всплески визитов, гео без аудитории. И что не является признаком.",
  type: "Гайд",
  category: "Поисковые системы",
  title: "Как понять, что на сайт идёт неестественный трафик",
  time: 8,
  data: "31.07.2026",
  imageUrl: "/blogImages/priznaki-neestestvennogo-trafika/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Разбираем, по каким признакам посторонний трафик видно в Яндекс
  Метрике, Вебвизоре и Вебмастере: где лежит отчёт «Мониторинг → Роботы», что
  в нём значит доля роботных визитов и на что смотреть кроме неё. Отдельно —
  список совпадений, которые кажутся тревожными, но признаком не являются.`,
  navigation: [
    { to: "zachem-proveryat", text: "Зачем это проверять" },
    { to: "otkuda-beretsya", text: "Откуда берётся посторонний трафик" },
    { to: "otchet-roboty", text: "Отчёт «Мониторинг → Роботы»" },
    { to: "sem-priznakov", text: "Семь признаков в отчётах" },
    { to: "webvizor", text: "Что показывает Вебвизор" },
    { to: "webmaster", text: "Что смотреть в Вебмастере" },
    { to: "ne-priznak", text: "Что признаком не является" },
    { to: "chto-delat-dalshe", text: "Что делать дальше" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "zachem-proveryat",
      title: "Зачем это проверять",
      content: [
        {
          type: "Description",
          text: "Неестественный трафик — это визиты, которые не принадлежат вашей аудитории: их совершает не человек, которому нужен ваш товар, а программа, сканер или исполнитель чужого задания. Часть такого трафика безобидна и есть у всех, часть искажает картину, по которой вы принимаете решения.",
        },
        {
          type: "Description",
          text: "Смотреть на это стоит по трём причинам:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Решения по цифрам. ", text: "Если четверть визитов роботные, конверсия, отказы и средняя длительность сессии у вас посчитаны неправильно, и вывод «страница плохая» может оказаться выводом о роботах." },
            { bold: "Расход бюджета. ", text: "Мусорные клики в рекламе — это деньги, потраченные на визиты, которые никогда не станут заявками." },
            { bold: "Качество сигналов для поиска. ", text: "Поисковые системы оценивают поведение посетителей. Массовые однотипные визиты не улучшают эту оценку — в лучшем случае они просто не учитываются." },
          ],
        },
        {
          type: "Footnote",
          textItalic: "Важная оговорка на весь материал: сама по себе доля роботных визитов — не диагноз. Диагноз — это изменение доли и совпадение нескольких признаков сразу.",
        },
      ],
    },
    {
      id: "otkuda-beretsya",
      title: "Откуда берётся посторонний трафик",
      content: [
        {
          type: "Description",
          text: "Прежде чем искать злой умысел, полезно разложить источники. Их обычно пять, и три из них к конкурентам отношения не имеют.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Поисковые и сервисные роботы. ", text: "Краулеры поисковиков, роботы мониторингов доступности, превью-боты мессенджеров. Это нормальная часть жизни сайта, блокировать их не нужно и вредно." },
            { bold: "Парсеры и сканеры. ", text: "Сбор цен и контента конкурентами, автоматический поиск уязвимостей. Обычно узнаётся по ровному темпу запросов и обходу по всему каталогу подряд." },
            { bold: "Мусорный трафик из рекламы. ", text: "Клики из сомнительных площадок рекламных сетей. Виден по источнику перехода и по нулевой глубине просмотра." },
            { bold: "Накрутка от конкурента. ", text: "Попытка испортить поведенческие метрики чужого сайта. Встречается заметно реже, чем о ней говорят, и обычно выглядит как всплеск однотипных коротких визитов." },
            { bold: "Работа вашего же подрядчика. ", text: "Самый частый случай из тех, что принимают за атаку: подрядчик по продвижению запустил инструмент и не предупредил. Прежде чем строить защиту, спросите об этом напрямую." },
          ],
        },
      ],
    },
    {
      id: "otchet-roboty",
      title: "Отчёт «Мониторинг → Роботы» в Яндекс Метрике",
      content: [
        {
          type: "Description",
          text: "Это первое место, куда стоит зайти. Метрика помечает часть визитов как роботные — по поведению и по спискам известных роботов — и показывает их долю за выбранный период. По умолчанию роботные визиты из отчётов исключены, поэтому в обычной статистике вы их не видите.",
        },
        {
          type: "Description",
          text: "Что делать в отчёте:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { text: "Выберите период не в один день, а в два-три месяца — нужна линия, а не точка." },
            { text: "Найдите дату, с которой доля изменилась. Если её нет и линия ровная — тревожиться не о чем, какой бы ни была абсолютная величина." },
            { text: "Сопоставьте эту дату с тем, что происходило у вас: запуск рекламы, публикация, начало работ подрядчика, переезд." },
          ],
        },
        {
          type: "Subtotal",
          title: "На что смотреть",
          text: "Не на абсолютную долю роботности, а на её динамику и на совпадение с событиями. У сайта с большим каталогом доля роботов всегда выше, чем у лендинга, и это нормально.",
        },
      ],
    },
    {
      id: "sem-priznakov",
      title: "Семь признаков, которые видно в отчётах",
      content: [
        {
          type: "Description",
          text: "По одному признаку выводов не делают. Тревожно становится, когда совпадают три и больше.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Всплеск прямых заходов без причины. ", text: "Прямые заходы растут, когда о вас говорят: реклама, рассылка, офлайн-активность. Рост без единого повода — повод посмотреть внимательнее." },
            { bold: "Одинаковая длительность визитов. ", text: "Живые сессии разбросаны по времени. Если сотни визитов укладываются в один и тот же интервал с точностью до секунд, за ними стоит расписание, а не интерес." },
            { bold: "География без вашей аудитории. ", text: "Заметный трафик из регионов и стран, где вы не продаёте и не рекламируетесь." },
            { bold: "Ровный поток ночью. ", text: "У живой аудитории есть суточный ритм и провал под утро. Автоматика работает круглосуточно и одинаково." },
            { bold: "Отказы на границах шкалы. ", text: "Доля отказов, ушедшая к нулю или к сотне процентов, — это почти всегда не изменение поведения, а появление однородной группы визитов." },
            { bold: "Однообразие технических параметров. ", text: "Один браузер, одна версия, одно разрешение экрана у большой группы визитов. В отчётах «Технологии» это видно сразу." },
            { bold: "Визиты растут, а показы в поиске — нет. ", text: "Если в Вебмастере число показов и кликов по запросам не изменилось, а Метрика рисует рост переходов, эти переходы пришли не из поиска." },
          ],
        },
      ],
    },
    {
      id: "webvizor",
      title: "Что показывает Вебвизор",
      content: [
        {
          type: "Description",
          text: "Отчёты дают статистику, Вебвизор — записи конкретных визитов. Это самый быстрый способ перевести подозрение в факт: вы просто смотрите десяток записей из подозрительной группы.",
        },
        {
          type: "Description",
          text: "На записях искусственный визит обычно узнаётся по отсутствию мелкой моторики: нет пауз на чтение, нет возвратов к прочитанному, нет случайных движений курсора, прокрутка идёт равномерно и до конца страницы или не идёт вовсе. Живой человек ведёт себя рвано — он отвлекается, возвращается, промахивается мимо ссылки.",
        },
        {
          type: "Footnote",
          textItalic: "Вебвизор стоит включить заранее. Записи хранятся ограниченное время, и если счётчик настроен уже после всплеска, разбираться будет не с чем.",
        },
      ],
    },
    {
      id: "webmaster",
      title: "Что смотреть в Яндекс Вебмастере",
      content: [
        {
          type: "Description",
          text: "Метрика показывает, что происходит на сайте, Вебмастер — что происходит с сайтом в поиске. Для диагностики нужны оба.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Поисковые запросы. ", text: "Динамика показов и кликов. Просадка сразу по всей группе запросов выглядит иначе, чем просадка по одной странице, и означает разные вещи." },
            { bold: "Брендовые запросы. ", text: "Отдельно посмотрите на запросы с названием компании. Если по ним всё в порядке, проблема, скорее всего, локальнее, чем кажется." },
            { bold: "Диагностика. ", text: "Раздел, где Яндекс сам сообщает о проблемах сайта. Начинать разбор стоит с него, а не с гипотез." },
            { bold: "Индексирование. ", text: "Резкий рост числа обходов страниц роботом иногда объясняет всплеск нагрузки, который приняли за атаку." },
          ],
        },
      ],
    },
    {
      id: "ne-priznak",
      title: "Что признаком не является",
      content: [
        {
          type: "Description",
          text: "Половина обращений «нас накручивают» — это нормальные события, совпавшие по времени.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Сезонный рост или спад — сравнивайте с тем же периодом прошлого года, а не с прошлым месяцем." },
            { text: "Всплеск после публикации, рассылки или упоминания в СМИ." },
            { text: "Рост доли роботов после того, как вы открыли для индексации большой раздел каталога." },
            { text: "Изменение цифр после переустановки счётчика, смены домена или подключения CDN — часть визитов начинает считаться иначе." },
            { text: "Единичные визиты со странной географией: за ними обычно VPN, а не атака." },
          ],
        },
        {
          type: "Subtotal",
          title: "Правило",
          text: "Сначала ищите объяснение среди собственных действий за последний месяц. Внешнюю причину имеет смысл рассматривать, когда своих не нашлось.",
        },
      ],
    },
    {
      id: "chto-delat-dalshe",
      title: "Что делать дальше",
      content: [
        {
          type: "Description",
          parts: [
            "Если признаки совпали и объяснение не нашлось — переходите к защите. Порядок действий, который работает, и список мер, которые только кажутся полезными, разобраны отдельно: ",
            { to: "/blog/zashchita-ot-nakrutki-konkurentami", text: "что делать, если конкуренты накручивают ваш сайт" },
            ". Технические способы отсечь ботов — блокировка по IP, антибот-скрипты, фильтрация по User-Agent — с плюсами и минусами каждого разобраны в материале про ",
            { to: "/blog/nakrutka-pf-osnovnye-metody", text: "методы накрутки поведенческих факторов" },
            ".",
          ],
        },
        {
          type: "Description",
          parts: [
            "Обратная задача — не отсечь чужой трафик, а получить свой — решается иначе. Сценарии, которые проходят живые исполнители со своих устройств, описаны на странице ",
            { to: "/nakrutka-pf-yandex", text: "накрутка ПФ Яндекс через тестировщиков" },
            "; поведенческие факторы в Google разобраны ",
            { to: "/blog/nuzhno-li-krutit-pf-dlya-google", text: "в отдельной статье" },
            ".",
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Начинайте с отчёта «Мониторинг → Роботы» в Метрике и смотрите на динамику доли, а не на её величину." },
            { text: "Один признак ничего не значит. Ищите совпадение трёх и больше." },
            { text: "Вебвизор переводит подозрение в факт быстрее любых отчётов." },
            { text: "Сверяйте Метрику с Вебмастером: рост визитов без роста показов означает, что трафик пришёл не из поиска." },
            { text: "Сначала исключите собственные действия и сезонность, и только потом — внешнюю причину." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
